import { customRecordingGetAllFormatted, customRecordingGetAllAnalytics } from "@/api/custom_recording";
import { tableHeaderConfigurationGetHeaders } from "@/api/table_header_configuration";
import mixin from "../../mixin";

const state = {
    top1000RecordingData: [],
    top1000TotalCount: null,
    summaryChart: null,
    columnHeader: [],
    isLoading: false,
    totalDataPoints: null
};

const mutations = {
    SET_RECORDING_DATA: (state, data) => {
        state.top1000RecordingData = data.items;
        state.top1000TotalCount = data.totalCount;
    },
    SET_COLUMN_HEADER: (state, data) => {
        state.columnHeader = data;
    },
    SET_TABLE_CHART: (state, data) => {
        state.summaryChart = data.items;
        state.totalDataPoints = data.totalDataPoints;
    },
    SET_IS_LOADING: (state, data) => {
        state.isLoading = data;
    },
    RESET_RECORDING_DATA: (state, data) => {
        state.top1000RecordingData = [],
        state.top1000TotalCount    = null,
        state.summaryChart         = null,
        state.columnHeader         = [];
    }
};

const actions = {
    async getRecordingData({ state, commit }, data) {
        try {
            state.isLoading = true;
            let res = await customRecordingGetAllFormatted({
                "skipCount": 0,
                "maxResultCount": 200,
                ...data
            });
            if (res) {
                commit("SET_RECORDING_DATA", res);
                commit("SET_IS_LOADING", false);
            }
        }
        catch {
            console.log("get recording failed");
        }
    },
    async getTableHeader({ state, commit }, data) {
        try {
            let res = await tableHeaderConfigurationGetHeaders({
                ...data,
                "IsShown": true
            });
            if (res) {
                let sorted_item = await mixin.methods.$_sortArrayObject(res.items, "sequence", "asc");
                let columns = await mixin.methods.$_formatTableConfigurationHeader(sorted_item);
                let formatted_col = columns.map(col => {
                    if (col.width == null && col.minWidth == null) {
                        col.minWidth = "80px";
                    }
                    return col;
                });

                console.log("columns ---", formatted_col);
                commit("SET_COLUMN_HEADER", formatted_col);
            }
        }
        catch {
            console.log("get recording header failed");
        }
    },
    async getTableChart({ state, commit }, data) {
        try {
            let res = await customRecordingGetAllAnalytics({
                ...data,
            });
            if (res) {
                commit("SET_TABLE_CHART", res);
            }
        }
        catch {
            console.log("get recording header failed");
        }
    },
    setColumnHeader({ state, commit }, data) {
        commit("SET_COLUMN_HEADER", data);
    },
    resetRecordingData({ state, commit }, data) {
        commit("RESET_RECORDING_DATA");
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/recording_data.js